import useGasMeters from '@/hooks/admin/useGasMeters'
import useLocations from '@/hooks/admin/useLocations'
import useMeters from '@/hooks/admin/useMeters'
import useWaterMeters from '@/hooks/admin/useWaterMeters'

/**
 * The org's locations and meters, from the same cached queries the admin
 * tables use — so opening a peek from one of those tables is instant.
 */
export default function useRelatedRecords() {
    const locations = useLocations()
    const electricity = useMeters()
    const gas = useGasMeters()
    const water = useWaterMeters()
    const queries = [locations, electricity, gas, water]
    return {
        locations: locations.data ?? [],
        electricity: electricity.data ?? [],
        gas: gas.data ?? [],
        water: water.data ?? [],
        // placeholderData makes `isLoading` false immediately, so wait on the
        // real fetch rather than peeking into an empty placeholder list.
        isLoading: queries.some(
            (query) => query.isPlaceholderData && query.isFetching
        )
    }
}
